// extracted by mini-css-extract-plugin
export default {"taskDetailsContainer":"TaskDetails_taskDetailsContainer__eI+6c","taskDetailRow":"TaskDetails_taskDetailRow__PEV8w"};